import { render, staticRenderFns } from "./OutputStudySetting.vue?vue&type=template&id=8220aad2"
import script from "./OutputStudySetting.vue?vue&type=script&lang=js"
export * from "./OutputStudySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports